import React from 'react'
import { Link } from 'react-router-dom'

function BlogLeftSidebar() {
  return (
    <div>
    
    <div className="breadcrumb-row">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-between align-items-center breadcrumb-item">
                            <div className="breadcrumb-title-heading">
                                <h1 className="title">Blog Grid Left</h1>
                            </div>
                            <div className="breadcrumb-wrapper">
                                <span className="mr-1"><i className="ti ti-home"></i></span>
                                <Link title="Homepage" to="/">Home</Link>
                                <span className="ttm-bread-sep">&nbsp;/&nbsp;</span>
                                <span className="ttm-textcolor-skincolor">Blog Left</span>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>                    
        </div>
    {/* <!-- Section Start --> */}
    <section className="section-padding">
        <div className="container-fluid">
            <div className="row">
                <aside className="col-lg-4">
                    <div className="sidebar">
                        <div className="sidebar_inner">
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Search</h5>
                                <form action="#" method="POST">
                                    <div className="input-group">
                                        <input type="text" name="#" className="form-control form-control-custom" placeholder="Search keywords..." autoComplete="off" required=""/>
                                        <div className="input-group-append">
                                            <button type="submit">
                                                <i className="fal fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Category</h5>
                                <ul className="categories">
                                    <li>
                                        <Link to="/blog">All <span>(267)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">Forming Tools <span>(50)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">Protecting Tools <span>(78)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">Construction Tools <span>(95)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">Flrefighter Tools <span>(15)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">Punch Tools <span>(65)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">Plumbing Tools <span>(62)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">Wrenches <span>(85)</span></Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Recent Post</h5>
                                <ul className="recent_post">
                                    <li>
                                        <div className="post_thumb">
                                            <Link to="/blog-details">
                                                <img src="/tm/react/toolways/assets/images/blog/1.jpg" className="image-fit" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="post_caption">
                                            <h6 className="post_title"><Link to="/blog-details">Cordless Machine</Link></h6>
                                            <p className="post_date">18 March 2024</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="post_thumb">
                                            <Link to="/blog-details">
                                                <img src="/tm/react/toolways/assets/images/blog/2.jpg" className="image-fit" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="post_caption">
                                            <h6 className="post_title"><Link to="/blog-details">Welding and Soldering</Link></h6>
                                            <p className="post_date">18 March 2024</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="post_thumb">
                                            <Link to="/blog-details">
                                                <img src="/tm/react/toolways/assets/images/blog/blog-4.jpg" className="image-fit" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="post_caption">
                                            <h6 className="post_title"><Link to="/blog-details">Safety tools</Link></h6>
                                            <p className="post_date">18 March 2024</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="post_thumb">
                                            <Link to="/blog-details">
                                                <img src="/tm/react/toolways/assets/images/blog/5.jpg" className="image-fit" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="post_caption">
                                            <h6 className="post_title"><Link to="/blog-details">Power Drill Machine</Link></h6>
                                            <p className="post_date">18 March 2024</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Tags</h5>
                                <div className="tag s_cloud">
                                    <Link to="/blog">All </Link>
                                    <Link to="/blog">Forming Tools</Link>
                                    <Link to="/blog">Protecting Tools</Link>
                                    <Link to="/blog">Construction Tools</Link>
                                    <Link to="/blog">Flrefighter Tools</Link>
                                    <Link to="/blog">Punch Tools</Link>
                                    <Link to="/blog">Plumbing Tools</Link>
                                    <Link to="/blog">Wrenches</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </aside>
                <div className="col-lg-8">
                    <div className="row justify-content-center">
                        <article className="col-md-6 post">
                            <div className="post_image">
                                <Link to="/blog-details">
                                    <img src="/tm/react/toolways/assets/images/blog/1.jpg" className="image-fit" alt="img"/>
                                </Link>
                                <Link to="/blog-details" className="post_date">
                                    18 Oct
                                </Link>
                            </div>
                            <div className="post_caption">
                                <ul className="post_meta">
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-user"></i>
                                            Admin
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-comments"></i>
                                            8.6k
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-eye"></i>
                                            9.5k
                                        </Link>
                                    </li>
                                </ul>
                                <h2 className="post_title">
                                    <Link to="/blog-details">Powerful Motor For The Best Performance Recompound Miter Saw</Link>
                                </h2>
                            </div>
                        </article>
                        <article className="col-md-6 post">
                            <div className="post_image">
                                <Link to="/blog-details">
                                    <img src="/tm/react/toolways/assets/images/blog/2.jpg" className="image-fit" alt="img"/>
                                </Link>
                                <Link to="/blog-details" className="post_date">
                                    18 Oct
                                </Link>
                            </div>
                            <div className="post_caption">
                                <ul className="post_meta">
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-user"></i>
                                            Admin
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-comments"></i>
                                            8.6k
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-eye"></i>
                                            9.5k
                                        </Link>
                                    </li>
                                </ul>
                                <h2 className="post_title">
                                    <Link to="/blog-details">Why You Need Any Popular Brand Tools</Link>
                                </h2>
                            </div>
                        </article>
                        <article className="col-md-6 post">
                            <div className="post_image">
                                <Link to="/blog-details">
                                    <img src="/tm/react/toolways/assets/images/blog/5.jpg" className="image-fit" alt="img"/>
                                </Link>
                                <Link to="/blog-details" className="post_date">
                                    18 Oct
                                </Link>
                            </div>
                            <div className="post_caption">
                                <ul className="post_meta">
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-user"></i>
                                            Admin
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-comments"></i>
                                            8.6k
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-eye"></i>
                                            9.5k
                                        </Link>
                                    </li>
                                </ul>
                                <h2 className="post_title">
                                    <Link to="/blog-details">Why We Used Best Hand Tools for used</Link>
                                </h2>
                               
                            </div>
                        </article>
                        <article className="col-md-6 post">
                            <div className="post_image">
                                <Link to="/blog-details">
                                    <img src="/tm/react/toolways/assets/images/blog/blog-4.jpg" className="image-fit" alt="img"/>
                                </Link>
                                <Link to="/blog-details" className="post_date">
                                    18 Oct
                                </Link>
                            </div>
                            <div className="post_caption">
                                <ul className="post_meta">
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-user"></i>
                                            Admin
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-comments"></i>
                                            8.6k
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-eye"></i>
                                            9.5k
                                        </Link>
                                    </li>
                                </ul>
                                <h2 className="post_title">
                                    <Link to="/blog-details">Do You Know How To Buy High Quality Products</Link>
                                </h2>
                            </div>
                        </article>
                        <article className="col-md-6 post">
                            <div className="post_image">
                                <Link to="/blog-details">
                                    <img src="/tm/react/toolways/assets/images/blog/blog-6.jpg" className="image-fit" alt="img"/>
                                </Link>
                                <Link to="/blog-details" className="post_date">
                                    18 Oct
                                </Link>
                            </div>
                            <div className="post_caption">
                                <ul className="post_meta">
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-user"></i>
                                            Admin
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-comments"></i>
                                            8.6k
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-eye"></i>
                                            9.5k
                                        </Link>
                                    </li>
                                </ul>
                                <h2 className="post_title">
                                    <Link to="/blog-details">Best and Most Advanced Machine</Link>
                                </h2>
                                
                            </div>
                        </article>
                        <article className="col-md-6 post">
                            <div className="post_image">
                                <Link to="/blog-details">
                                    <img src="/tm/react/toolways/assets/images/blog/blog-1.jpg" className="image-fit" alt="img"/>
                                </Link>
                                <Link to="/blog-details" className="post_date">
                                    18 Oct
                                </Link>
                            </div>
                            <div className="post_caption">
                                <ul className="post_meta">
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-user"></i>
                                            Admin
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-comments"></i>
                                            8.6k
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            <i className="fal fa-eye"></i>
                                            9.5k
                                        </Link>
                                    </li>
                                </ul>
                                <h2 className="post_title">
                                    <Link to="/blog-details">Cordless Power And New Products</Link>
                                </h2>
                            </div>
                        </article>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <nav>
                                <ul className="pagination">
                                    <li className="page-item">
                                        <Link className="page-link" to="#" aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span className="sr-only">Previous</span>
                                        </Link>
                                    </li>
                                    <li className="page-item active"><Link className="page-link" to="#">1</Link></li>
                                    <li className="page-item"><Link className="page-link" to="#">2</Link></li>
                                    <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                                    <li className="page-item">
                                        <Link className="page-link" to="#" aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span className="sr-only">Next</span>
                                        </Link>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default BlogLeftSidebar